const CACHE_NAME = 'my-image-cache-v1';

export async function cacheImage(url: string) {
  const cache = await caches.open(CACHE_NAME);

  const match = await cache.match(url);
  if (!match) {
    const response = await fetch(url, { mode: 'cors' });
    if (response.ok) {
      await cache.put(url, response.clone());
      console.log(`Cached ${url}`);
    }
  } else {
    console.log(`Already cached ${url}`);
  }
}

export async function getImageFromCache(url: string): Promise<string | null> {
  const cache = await caches.open(CACHE_NAME);
  const match = await cache.match(url);

  if (match) {
    const blob = await match.blob();
    return URL.createObjectURL(blob);
  }

  return null;
}

export async function loadImage(url: string) {
  let imageUrl = await getImageFromCache(url);

  if (!imageUrl) {
    await cacheImage(url);
    imageUrl = await getImageFromCache(url);
  }

  return imageUrl;
}